export const mailtoLink =
  "mailto:johnmrichard35@gmail.com?subject=I%E2%80%99d%20love%20to%20connect%20with%20you%20John!";
